import { inject, NgModule } from '@angular/core';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterModule, Routes, RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { VerifyPaymentComponent } from './common/components/verify-payment/verify-payment.component';
import { ShopsComponent } from './partners/shops/shops.component';
import { MerchantHomeComponent } from './partners/merchant-home/merchant-home.component';
import { PartnerSignupComponent } from './partners/partner-signup/partner-signup.component';
import { ShariaBoardComponent } from './sharia-board/sharia-board.component';
import { AppRedirectComponent } from './app-redirect/app-redirect.component';
import { CompleteApplicationComponent } from './partners/complete-application/complete-application.component';
import { PageUnderMaintenanceComponent } from './page-under-maintenance/page-under-maintenance.component';
import { CustomerComplaintsComponent } from './customer-complaints/customer-complaints.component';

@Injectable({ providedIn: 'root' })
export class TemplatePageTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  constructor() {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);
    if (title !== undefined) {
      this.title.setTitle(`Taly Shop Now Pay Later | ${title}`);
    }
  }
}

const routes: Routes = [
  // Complete application route - must be before home module to avoid catch-all
  // Token is passed as query param: /complete-application?token=xxx
  {
    path: 'maintenance-page',
    component: PageUnderMaintenanceComponent,
    title: 'Page Under Maintenance',
  },
  {
    path: 'complete-application',
    component: CompleteApplicationComponent,
    data: {
      role: 'COMPLETE_APPLICATION',
    },
    title: 'Complete Application',
  },
  {
    path: 'health',
    loadComponent: () => import('./health/health.component').then((m) => m.HealthComponent),
    title: 'Health Check',
  },
  {
    path: 'kyc',
    loadComponent: () => import('./kyc/kyc.component').then((m) => m.KycComponent),
    title: 'KYC Verification',
  },
  {
    path: '',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
    pathMatch: 'full',
  },
  {
    path: 'mastercard/cancelled',
    component: VerifyPaymentComponent,
    data: { paymentType: 'mastercard', status: 'cancelled' },
    title: 'Payment Verification',
  },
  {
    path: 'mastercard/timeout',
    component: VerifyPaymentComponent,
    data: { paymentType: 'mastercard', status: 'timeout' },
    title: 'Payment Verification',
  },
  {
    path: ':paymentType/status',
    component: VerifyPaymentComponent,
    title: 'Payment Verification',
  },
  {
    path: ':paymentType/status/:orderId',
    component: VerifyPaymentComponent,
    title: 'Payment Verification',
  },
  {
    path: 'terms-and-conditions',
    loadChildren: () =>
      import('./terms-and-conditions/terms-and-conditions.module').then(
        (m) => m.TermsAndConditionsModule
      ),
  },
  {
    path: 'press',
    loadChildren: () =>
      import('./press-release/press-release.module').then((m) => m.PressReleaseModule),
  },
  {
    path: 'privacy-policy',
    loadChildren: () =>
      import('./privacy-policy/privacy-policy.module').then((m) => m.PrivacyPolicyModule),
  },
  // {
  //   path: 'partners',
  //   loadChildren: () => import('./partners/partners.module').then((m) => m.PartnersModule),
  // },
  {
    path: 'partner/sign-up',
    component: PartnerSignupComponent,
    data: {
      role: 'PARTNER_SIGNUP',
    },
    title: 'Become a Partner',
  },
  {
    path: 'shops',
    component: ShopsComponent,
    data: {
      role: 'SHOPS',
    },
    title: 'Shops',
  },
  {
    path: 'sharia-board',
    component: ShariaBoardComponent,
    data: {
      role: 'SHARIA_BOARD',
    },
    title: 'Sharia board',
  },
  {
    path: 'partner',
    component: MerchantHomeComponent,
    data: {
      role: 'LEARN_MORE',
    },
    title: 'Learn More',
  },
  {
    path: 'customer-complaints',
    component: CustomerComplaintsComponent,
    data: {
      role: 'CUSTOMER_COMPLAINTS',
    },
    title: 'Customer Complaints',
  },
  {
    path: 'secure-checkout',
    loadChildren: () => import('./checkout/checkout.module').then((m) => m.CheckoutModule),
  },
  {
    path: 'faq',
    loadChildren: () => import('./faq/faq.module').then((m) => m.FaqModule),
  },
  {
    path: 'faq-shopper',
    loadChildren: () => import('./faq/faq.module').then((m) => m.FaqModule),
  },
  {
    path: 'faq-partner',
    loadChildren: () => import('./faq/faq.module').then((m) => m.FaqModule),
  },
  {
    path: 'learn-more',
    loadChildren: () => import('./how-it-work/how-it-work.module').then((m) => m.HowItWorkModule),
  },
  { path: 'app', component: AppRedirectComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
  exports: [RouterModule],
  providers: [{ provide: TitleStrategy, useClass: TemplatePageTitleStrategy }],
})
export class AppRoutingModule {}
